import axios from '../axios-auth';
import orginal_axios from "axios";

export const saleReportService = {
    getSaleReportList,
    getSaleSummaryList,
    getAllSaleReportList,
    exportSaleReportExcel,
    getCreditList,
    printSaleSummay
}

function getCreditList(searchParams, page, size, sortedBy) {
    let url = '';
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    if (sortedBy == 'null,asc') {
        url = '/auth/sale-credit?page=' + page + '&size=' + size;
    } else {
        url = '/auth/sale-credit?page=' + page + '&size=' + size + '&sort=' + sortedBy;
    }

    if (searchParams.counterId) {
        url += '&counterId=' + searchParams.counterId;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.saleNo) {
        url += '&saleNo=' + searchParams.saleNo;
    }
    if (searchParams.userName) {
        url += '&userName=' + searchParams.userName;
    }
    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.fromTime) {
        url += '&fromTime=' + searchParams.fromTime;
    }
    if (searchParams.toTime) {
        url += '&toTime=' + searchParams.toTime;
    }
    if (searchParams.payType) {
        url += '&payType=' + searchParams.payType;
    }
    if (searchParams.cashierId) {
        url += '&cashierId=' + searchParams.cashierId;
    }
    if (searchParams.salePersonId) {
        url += '&salePersonId=' + searchParams.salePersonId;
    }
    return axios.get(url);
}
function getSaleReportList(searchParams, page, size, sortedBy) {
    let url = '';
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    if (sortedBy == 'null,asc') {
        url = '/auth/sale-report?page=' + page + '&size=' + size;
    } else {
        url = '/auth/sale-report?page=' + page + '&size=' + size + '&sort=' + sortedBy;
    }

    if (searchParams.counterId) {
        url += '&counterId=' + searchParams.counterId;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.saleNo) {
        url += '&saleNo=' + searchParams.saleNo;
    }
    if (searchParams.userName) {
        url += '&userName=' + searchParams.userName;
    }
    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.fromTime) {
        url += '&fromTime=' + searchParams.fromTime;
    }
    if (searchParams.toTime) {
        url += '&toTime=' + searchParams.toTime;
    }
    if (searchParams.payType) {
        url += '&payType=' + searchParams.payType;
    }
    if (searchParams.cashierId) {
        url += '&cashierId=' + searchParams.cashierId;
    }
    if (searchParams.salePersonId) {
        url += '&salePersonId=' + searchParams.salePersonId;
    }
    if (searchParams.currencyId) {
        url += '&currencyId=' + searchParams.currencyId;
    }
    return axios.get(url);
}

function getAllSaleReportList(searchParams) {
    let url = '';
    url = '/auth/sale-report?'
    if (searchParams.fromDate) {
        url += 'fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.counterId) {
        url += '&counterId=' + searchParams.counterId;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.saleNo) {
        url += '&saleNo=' + searchParams.saleNo;
    }
    if (searchParams.userName) {
        url += '&userName=' + searchParams.userName;
    }
    if (searchParams.fromTime) {
        url += '&fromTime=' + searchParams.fromTime;
    }
    if (searchParams.toTime) {
        url += '&toTime=' + searchParams.toTime;
    }
    if (searchParams.payType) {
        url += '&payType=' + searchParams.payType;
    }
    if (searchParams.cashierId) {
        url += '&cashierId=' + searchParams.cashierId;
    }
    if (searchParams.currencyId) {
        url += '&currencyId=' + searchParams.currencyId;
    }
    return axios.get(url);
}

function getSaleSummaryList(searchParams) {

    let url = '/auth/sale-summary-report?';

    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.counterId) {
        url += '&counterId=' + searchParams.counterId;
    }
    if (searchParams.saleNo) {
        url += '&saleNo=' + searchParams.saleNo;
    }
    if (searchParams.userName) {
        url += '&userName=' + searchParams.userName;
    }
    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.fromTime) {
        url += '&fromTime=' + searchParams.fromTime;
    }
    if (searchParams.toTime) {
        url += '&toTime=' + searchParams.toTime;
    }
    if (searchParams.payType) {
        url += '&payType=' + searchParams.payType;
    }
    if (searchParams.cashierId) {
        url += '&cashierId=' + searchParams.cashierId;
    }
    if (searchParams.currencyId) {
        url += '&currencyId=' + searchParams.currencyId;
    }
    return axios.get(url);
}

function exportSaleReportExcel(searchParams,sortedBy) {
    let url = '';
    if (sortedBy == 'null,asc') {
        url = '/auth/sale-report-excel?';
    } else {
        url = '/auth/sale-report-excel?' + '&sort=' + sortedBy;
    }

    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.counterId) {
        url += '&counterId=' + searchParams.counterId;
    }
    if (searchParams.saleNo) {
        url += '&saleNo=' + searchParams.saleNo;
    }
    if (searchParams.userName) {
        url += '&userName=' + searchParams.userName;
    }
    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.fromTime) {
        url += '&fromTime=' + searchParams.fromTime;
    }
    if (searchParams.toTime) {
        url += '&toTime=' + searchParams.toTime;
    }
    if (searchParams.payType) {
        url += '&payType=' + searchParams.payType;
    }
    if (searchParams.cashierId) {
        url += '&cashierId=' + searchParams.cashierId;
    }
    if (searchParams.currencyId) {
        url += '&currencyId=' + searchParams.currencyId;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + url,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function printSaleSummay(searchParams) {
    let url = '/auth/print-sale-summary?';

    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.counterId) {
        url += '&counterId=' + searchParams.counterId;
    }
    if (searchParams.saleNo) {
        url += '&saleNo=' + searchParams.saleNo;
    }
    if (searchParams.userName) {
        url += '&userName=' + searchParams.userName;
    }
    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.fromTime) {
        url += '&fromTime=' + searchParams.fromTime;
    }
    if (searchParams.toTime) {
        url += '&toTime=' + searchParams.toTime;
    }
    if (searchParams.payType) {
        url += '&payType=' + searchParams.payType;
    }
    if (searchParams.cashierId) {
        url += '&cashierId=' + searchParams.cashierId;
    }
    if (searchParams.currencyId) {
        url += '&currencyId=' + searchParams.currencyId;
    }
    return axios.get(url);
}